import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import BCBenxehang from "components/Baocao/Benxe/BCBenxehang.js";
import BCBenxekhach from "components/Baocao/Benxe/BCBenxekhach.js";
export default function BCBenxe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo bến xe khách",
            tabContent: <BCBenxekhach />,
          },
          {
            tabName: "Báo cáo bến xe hàng",
            tabContent: <BCBenxehang />,
          },
        ]}
      />
    </div>
  );
}
